
import React, { createContext, useState, useEffect } from 'react';
import GetToken from "../GetToken";
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from "sweetalert2";
import axios from "axios";
import { handleInvalidToken } from "../AuthUtils";
import { toast } from 'react-toastify';
export const AppContext = createContext();

// provider component
export const AppProvider = ({ children }) => {
	const location = useLocation();
	const [isSidebarOpen, setIsSidebarOpen] = useState(false);
	const [avatar, setAvatar] = useState("");
	const [isSmallScreen, setIsSmallScreen] = useState(false);
	const [hasModelAccess, setHasModelAccess] = useState(false);
	const [isWlFileDownloadReady, setWLDownloadFileReady] = useState(true);
	const [accessAIModels, setAccessAIModels] = useState([
		"WYvamApMq742f3f21140aa97de8a80bf1bce676f2",
		"IJdi6g8Qq86211c62b5e39dc47b04c531439d98f7",
		"sfc6ohdCw183f73fbb942b01c66946415bca2c624",
		"UCV2p6GYf69225ab1bff65831b158f65eb8aec605",
		"0gy3rfHju56f82897c0f9827cdd34466837b89852",
		"HQwZjkytoe70af57e3d1fdd49641bd017b9c073e6",
		"Xj8SDQ9Gfd3ccc9eccc0e19967c80acc7b5c735f2",
		"n0ZRjxOeY545ac97317a6daa03ef1a0efabfe099c"
	]);
	const [packageAccess, setPackageAccess] = useState([]);
	const [features, setFeatures] = useState([]);
	const [filterModelActive, setFilterModelActive] = useState(false)
	const navigate = useNavigate();
	// let isChapterEditor = false;
	const base_url =
		window.location.hostname === "localhost"
			? "http://localhost/aitalkingbooks/"
			: window.location.hostname === "192.168.29.228"
				? "http://192.168.29.228/aitalkingbooks/"
				: "https://bookflowai.com/api/";

	const setPermissions = (package_access, features_array) => {
		setPackageAccess(package_access);
		setFeatures(features_array);
	};

	// useEffect(() => {
	// 	console.log("pathname changing")
	// 	isChapterEditor = location.pathname.includes("/edit");
	// }, [location.pathname])

	const clearPermissions = () => {
		setPackageAccess([]);
		setFeatures([]);
		setHasModelAccess(false);
	};



	const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

	const handleResize = () => {
		if (window.innerWidth < 768) {
			setIsSidebarOpen(false);
			setIsSmallScreen(true);
		}
		else {
			setIsSidebarOpen(true);
			setIsSmallScreen(false);
		}

	};
	useEffect(() => {
		handleResize();
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const fetchMenuPermissions = async () => {
		try {
			const token = GetToken();

			if (!token) {
				return;
			}

			const formData = new FormData();
			formData.append("action", "getPermissions");
			formData.append("token", token);

			const response = await axios.post(`${base_url}api/user/get-user-resource`, formData);

			if (response.data.status === true) {
				setPackageAccess(response.data.package_access);
				setFeatures(response.data.features);
				setWLDownloadFileReady(response.data.wlFileDownloadReady ?? true);
				if (response.data.package_access.includes("premium")) {
					setHasModelAccess(true);
				}
			}
		} catch (error) {
			toast.error(error.response?.data?.message ||
				error.message ||
				"Something went wrong. Please try again.");
		}
	};
	
	useEffect(() => {
		fetchMenuPermissions();
	}, []);
	return (
		<AppContext.Provider value={{ handleResize, isSidebarOpen, isSmallScreen, toggleSidebar, setIsSidebarOpen, base_url, clearPermissions, fetchMenuPermissions, packageAccess, features, filterModelActive, setFilterModelActive, accessAIModels, isWlFileDownloadReady, avatar, setAvatar }}>
			{children}
		</AppContext.Provider>
	);
};
